import React from "react";

export default props => {
  return (
    <div style={{ position: "relative" }}>
      <div
        {...props}
        style={{
          zIndex: 999,
          position: "absolute",
          pointerEvents: "none",
          display: "flex"
        }}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/AbsoluteLabel/index.js